export const dataCountry = [
  { id: "ID", name: "Indonesia" },
  { id: "SG", name: "Singapore" },
  { id: "MY", name: "Malaysia" },
  { id: "TH", name: "Thailand" },
  { id: "VN", name: "Vietnam" },
];
